<ion-card class="status-card">
  <h4 class="date-time">
    {{ eventTime }}
  </h4>
  <ion-row class="multi-info">
    <div class="source-event">
      <p class="text custom-mr">{{ CONSTANTS.SOURCE }} {{ sourceData }}</p>
      <p class="text">
        {{ CONSTANTS.EVENT }}
        {{ eventType }}
      </p>
    </div>
    <p class="text">{{ CONSTANTS.USER_ID }} {{ userIdData }}</p>
  </ion-row>
  <div class="line-seperator"></div>
  <ng-content></ng-content>
</ion-card>
